// src/pages/LinksBoard.js
import React, { useState, useEffect } from 'react';
import BBSHeader from '../components/BBS/BBSHeader';
import BBSNav from '../components/BBS/BBSNav';
import StatusBar from '../components/BBS/StatusBar';

const CATEGORY_LABELS = {
  social: '📡 SOCIAL CHANNELS',
  story: '📖 STORY LINKS',
  world: '🌐 FRIENDS',
  game: '🎮 INTERACTIVE',
  external: '🔗 EXTERNAL LINKS',
  general: '░░ GENERAL',
};

const CATEGORY_ORDER = ['social', 'story', 'world', 'game', 'external', 'general'];

export default function LinksBoard() {
  const [links, setLinks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/api/links')
      .then(res => res.json())
      .then(data => {
        setLinks(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  // Group links by category
  const grouped = {};
  links.forEach(link => {
    const cat = link.category || 'general';
    if (!grouped[cat]) grouped[cat] = [];
    grouped[cat].push(link);
  });

  return (
    <div>
      <BBSHeader title="LINKS BOARD" subtitle="CONNECTIONS TO THE NETWORK" />
      <BBSNav />

      {loading ? (
        <div className="bbs-loading">
          SCANNING NETWORK<span className="bbs-loading-dots" />
        </div>
      ) : (
        CATEGORY_ORDER.map(cat => {
          if (!grouped[cat] || grouped[cat].length === 0) return null;
          return (
            <div key={cat} className="bbs-link-section">
              <div className="bbs-link-section-title">
                {CATEGORY_LABELS[cat] || cat.toUpperCase()}
              </div>
              {grouped[cat].map(link => (
                <a
                  key={link.id}
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bbs-link-item"
                >
                  <div className="link-title">{'> '}{link.title}</div>
                  {link.description && (
                    <div className="link-desc">{link.description}</div>
                  )}
                </a>
              ))}
            </div>
          );
        })
      )}

      <div style={{ marginTop: '30px', color: '#333', textAlign: 'center', fontSize: '0.85rem' }}>
        ─── All connections monitored by Ophidia Global ───
      </div>

      <StatusBar />
    </div>
  );
}